import { get } from 'lodash';
import formatShortDate from 'common/utils/Dates/formatShortDate';

const parseRelationships = (relationships = {}) => Object.entries(relationships).reduce((acc, [key, value]) => ({
  ...acc,
  [key]: value?.data,
}), {});

export const getPersonData = (data, authorization, includeInternalNonConsentedClients) => {
  if (includeInternalNonConsentedClients) {
    const [includedPerson] = get(data, 'data.included', []);
    return includedPerson ? {
      id: includedPerson.id,
      ...includedPerson.attributes,
      ...parseRelationships(includedPerson.relationships),
    } : {};
  }
  return get(authorization, 'person', {});
};

export const getDisplayDates = (authorization) => {
  const dateRequestedStartsAt = formatShortDate(authorization.requested_starts_at);
  const dateRequestedEndsAt = formatShortDate(authorization.requested_ends_at);
  const isSingleDateRequested = authorization.requested_starts_at === authorization.requested_ends_at;

  return {
    dateRequestedStartsAt,
    dateRequestedEndsAt,
    isSingleDateRequested,
  };
};

export const hasRequestedOrInReviewEdition = (authorization) => (
  authorization.lineage?.some((auth) => (
    auth.id !== authorization.id &&
    (auth.state === 'requested' || auth.state === 'in_review')
  ))
);
